/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2023-01-12 11:30:43
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-12 20:19:57
 */
import { defineStore } from '@main/common/config/defineStore'

export default defineStore('cachedView', {
  state: () => ({
    visitedViews: [],
    cachedViews: []
  }),
  // 相当于 vue 中的 computed 计算属性 返回一个数值
  getters: {},
  actions: {
    addView(view) {
      this.addVisitedView(view)
      this.addCachedView(view)
    },
    addVisitedView(view) {
      // if (this.visitedViews.some((v) => v.path === view.path)) return
      // this.visitedViews.push(
      //   Object.assign({}, view, {
      //     title: view?.meta.title ?? 'no-name'
      //   })
      // )
    },
    addCachedView(view) {
      if (this.cachedViews.includes(view.name)) return
      if (view.meta && view.meta.keepAlive) {
        this.cachedViews.push(view.name)
      }
    },
    delVisitedView(view) {
      for (const [i, v] of this.visitedViews.entries()) {
        if (v.path === view.path) {
          this.visitedViews.splice(i, 1)
          break
        }
      }
    },
    delCachedView(view) {
      const index = this.cachedViews.indexOf(view.name)
      if (index > -1) {
        this.cachedViews.splice(index, 1)
      }
    }
  }
})
